<template>
  <div class="shortlist-result-list col-12 q-mb-sm" v-if="shortlist.length">
    <CustomExpansionItem
      :label="`Shortlisted vehicles ${shortlist.length ? '(' + shortlist.length + ')' : ''}`"
      v-model="localShowShortlistedVehicles"
      :headerStyle="{ color: 'var(--q-color-primary)' }"
      :headerClass="`shortlist-label`"
    >
      <template v-if="user !== null">
        <VehicleShortlistCard
          v-for="(vehicle, index) in shortlist"
          :key="index"
          class="view-shortlist-result-card"
          :imagePath="vehicle.jatoImagepath"
          :imagePathBase="vehicle.jatoImagepathBase"
          :imagePathTrim="vehicle.jatoImagepathTrim"
          :fuelType="`${vehicle.catalogYear} | ${vehicle.vehiclePrimaryfueltype} | ${vehicle.vehicleTransmissiongroup}`"
          :vehicleDescription="formatDescription(vehicle)"
          :vehicleName="`${formatWordsAsSentences(vehicle.vehicleMake)} ${formatWordsAsSentences(vehicle.vehicleModel)} ${
            vehicle.vehicleTrim || ''
          } |  ${vehicle.vehicleDrivetrain}`"
          :weeklyPrice="vehicle.weekLeaseprice"
          :monthlyPrice="vehicle.monthLeaseprice"
          :rrp="vehicle.consumerPrice"
          :repaymentOption="repayment"
          :catalogVehicleId="vehicle.catalogVehicleId"
          :vehicleMake="vehicle.vehicleMake"
          :vehicleModel="vehicle.vehicleModel"
          :vehicleTrim="vehicle.vehicleTrim || ''"
          :vehicleDrivetrain="vehicle.vehicleDrivetrain || ''"
          :vehicleFinance="vehicle.vehicleFinance"
          :vehicleFinanceWeekly="vehicle.vehicleFinanceWeekly"
          :vehicleRunningCost="vehicle.vehicleRunningCost"
          :vehicleRunningCostWeekly="vehicle.vehicleRunningCostWeekly"
          :vehicle="vehicle"
          @onRemoveShortlist="$emit('removeShortlist', vehicle)"
          @onInfoIconClick="$emit('infoIconClick', true)"
          @onHandleEnquireNow="$emit('enquireNow', true, vehicle)"
          @onPricingInfoIconClick="$emit('pricingInfoIconClick')"
          expanded
        />
      </template>
      <template v-else>
        <VehicleResultCard
          v-for="vehicle in shortlist"
          :key="vehicle.catalogVehicleId"
          class="q-mb-md"
          v-model="vehicle.isShortlisted"
          :imagePath="vehicle.jatoImagepath"
          :imagePathBase="vehicle.jatoImagepathBase"
          :imagePathTrim="vehicle.jatoImagepathTrim"
          :fuelType="`${vehicle.catalogYear} | ${vehicle.vehiclePrimaryfueltype} | ${vehicle.vehicleTransmissiongroup}`"
          :vehicleDescription="formatDescription(vehicle)"
          :vehicleName="`${formatWordsAsSentences(vehicle.vehicleMake)} ${formatWordsAsSentences(vehicle.vehicleModel)} ${
            vehicle.vehicleTrim || ''
          } |  ${vehicle.vehicleDrivetrain}`"
          :weeklyPrice="vehicle.weekLeaseprice"
          :monthlyPrice="vehicle.monthLeaseprice"
          :rrp="vehicle.consumerPrice"
          :repaymentOption="repayment"
          :catalogVehicleId="vehicle.catalogVehicleId"
          :vehicleMake="vehicle.vehicleMake"
          :vehicleModel="vehicle.vehicleModel"
          :vehicleTrim="vehicle.vehicleTrim || ''"
          :vehicleDrivetrain="vehicle.vehicleDrivetrain || ''"
          :vehicleFinance="vehicle.vehicleFinance"
          :vehicleFinanceWeekly="vehicle.vehicleFinanceWeekly"
          :vehicleRunningCost="vehicle.vehicleRunningCost"
          :vehicleRunningCostWeekly="vehicle.vehicleRunningCostWeekly"
          :vehicle="vehicle"
          @input="$emit('input', vehicle)"
          :disabled="disableShortlist"
          @onInfoIconClick="$emit('infoIconClick', true)"
          @onHandleEnquireNow="$emit('enquireNow', true, vehicle)"
          @onPricingInfoIconClick="$emit('pricingInfoIconClick')"
        />
      </template>
    </CustomExpansionItem>
  </div>
</template>

<script>
import CustomExpansionItem from '../CustomExpansionItem';
import VehicleShortlistCard from '../ViewShortlist/VehicleShortlistCard';
import VehicleResultCard from './VehicleResultCard';
import { formatWordsAsSentences } from '../../../utils/calculator/wordFormatter';
import { formatVehicleDescription } from '../../../utils/calculator/vehicleFormatter';

export default {
  name: 'ShortlistSection',
  components: {
    CustomExpansionItem,
    VehicleShortlistCard,
    VehicleResultCard
  },
  props: {
    shortlist: {
      type: Array,
      default: () => [],
      required: true
    },
    user: {
      type: Object,
      default: null
    },
    repayment: {
      type: String,
      default: 'weekly'
    },
    showShortlistedVehicles: {
      type: Boolean,
      default: false
    },
    disableShortlist: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localShowShortlistedVehicles: this.showShortlistedVehicles
    };
  },
  methods: {
    formatWordsAsSentences,
    formatDescription(vehicle) {
      return formatVehicleDescription(vehicle);
    }
  },
  watch: {
    showShortlistedVehicles(value) {
      this.localShowShortlistedVehicles = value;
    },
    localShowShortlistedVehicles(value) {
      this.$emit('update:showShortlistedVehicles', value);
    }
  }
};
</script>
